export const MANUAL = 0;
export const AUTO = 1;
export const MULTIPLIER = 2;

export const TYPES = {
    [MANUAL]: 'Manual',
    [AUTO]: 'Auto',
    [MULTIPLIER]: 'Multiplier'
}
